module.exports = __webpack_public_path__ + "static/media/working-login2.c1b64600.png";